// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c6aa85b4","488":"0ff83aae"}[chunkId] + ".chunk.js";
};